import { useNavigate } from 'react-router-dom';
import { ShieldAlert, RefreshCcw, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';

const ErroPermissoes = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-background">
      <Card className="w-full max-w-md border-destructive/30 shadow-lg animate-in fade-in zoom-in duration-300">
        <CardHeader className="items-center text-center pb-2">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
            <ShieldAlert className="h-8 w-8 text-destructive" aria-hidden="true" />
          </div>
          <CardTitle className="text-2xl font-bold tracking-tight">Erro de Permissões</CardTitle>
          <CardDescription className="text-base mt-2">
            Não foi possível carregar seus perfis de acesso. Isso pode ocorrer devido a uma falha na conexão ou problema temporário no servidor.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6 pt-4">
          <div className="rounded-lg border bg-muted/30 p-4 text-sm text-muted-foreground leading-relaxed">
            <p>
              Tente recarregar a página para restabelecer a sessão. Se o problema persistir, saia da conta e entre novamente.
            </p>
          </div>
          
          <div className="flex flex-col gap-3">
            <Button 
              size="lg"
              className="w-full font-semibold shadow-sm" 
              onClick={handleReload}
            >
              <RefreshCcw className="mr-2 h-4 w-4" />
              Recarregar Sistema
            </Button>
            
            <Button 
              variant="outline" 
              size="lg"
              className="w-full font-semibold border-destructive/20 text-destructive hover:bg-destructive/5 hover:text-destructive" 
              onClick={handleLogout}
            >
              <LogOut className="mr-2 h-4 w-4" />
              Sair da Conta
            </Button>
          </div>
          
          <p className="text-center text-xs text-muted-foreground/60">
            Caso o erro persista após estas ações, entre em contato com o suporte de TI.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default ErroPermissoes;
